export const industries = [
  { icon: "precision_manufacturing", label: "Engineering" },
  { icon: "local_hospital", label: "Health" },
  { icon: "bolt", label: "Energy" },
  { icon: "directions_car", label: "Automotive" },
  { icon: "oil_barrel", label: "Oil and Gas" },
  { icon: "storefront", label: "Retail and Distribution" },
];
